import React, { useState, useEffect } from "react";
import { FaUserTie, FaBuilding, FaQuoteLeft } from "react-icons/fa";
import "../../assets/css/Jobs.css"; // reuse global styles

const SatisfactionSection = () => {
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        const response = await fetch("https://mysafari.safari-technologies.com/api/enquete-satisfaction");
        const data = await response.json();
        setSurveys(data.slice(0, 4)); // show 4 latest testimonials
      } catch (err) {
        console.error("Erreur:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSurveys();
  }, []);

  return (
    <section className="container text-center my-5">
      <h2 className="swiper-title mb-5">Témoignages de nos partenaires</h2>

      {loading ? (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-3">Chargement des témoignages...</p>
        </div>
      ) : (
        <div className="row justify-content-center">
          {surveys.map((survey, index) => (
            <div className="col-md-6 col-lg-4 mb-4" key={index}>
              <div className="card shadow-sm border-0 rounded-4 p-4 h-100">
                <FaQuoteLeft className="text-secondary mb-3" size={20} />
                <p className="text-dark fst-italic">"{survey.Commentaire}"</p>
                <hr />
                <p className="fw-bold mb-0">
                  <FaUserTie className="me-2 text-primary" />
                  {survey.Prenom} {survey.Nom?.charAt(0)}.
                </p>
                <p className="text-muted mb-0 small">
                  <FaBuilding className="me-1" /> {survey.Entreprise}
                </p>
                <p className="text-muted small">{survey.Poste}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Button to view all testimonials */}
      <div className="text-center mt-4">
        <a href="/enquete-satisfaction" className="btn btn-outline-primary rounded-pill px-4">
          Voir tous les témoignages
        </a>
      </div>
    </section>
  );
};

export default SatisfactionSection;
